// Meta Pixel helper — standalone, framework-free
const PIXEL_ID = '1561165498518499'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

/**
 * Injects the Meta Pixel base code (once), initializes the pixel,
 * and fires the initial PageView. Safe to call multiple times.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  try {
    /* eslint-disable */
    ;(function (f: any, b: Document, e: string, v: string) {
      if (f.fbq) return
      const n: any = (f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      })
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []
      const t = b.createElement(e) as HTMLScriptElement
      t.async = true
      t.src = v
      const s = b.getElementsByTagName(e)[0]
      s.parentNode?.insertBefore(t, s)
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    )
    /* eslint-enable */

    window.fbq('init', PIXEL_ID)
    window.fbq('track', 'PageView')
  } catch (err) {
    // Never let analytics break the page render
    console.warn('Meta Pixel init failed:', err)
  }
}

/**
 * Fires the AddToCart standard event. Call this when the user clicks a
 * checkout button that redirects to the Shopify product page.
 */
export function trackAddToCart(): void {
  if (typeof window === 'undefined' || !window.fbq) return
  try {
    window.fbq('track', 'AddToCart', {
      content_name: 'El Azúcar Silencioso',
      currency: 'USD',
      value: 17.95,
    })
  } catch (err) {
    console.warn('Meta Pixel AddToCart failed:', err)
  }
}
